/* Publish by EComposer at 2026-09-29 15:25:19*/
;try{
 /* =========================================================
   ASTROYA - TIRAGE DE DES
   Zone : EComposer > Custom JavaScript
   ES5 strict - ASCII pur (accents en \uXXXX)
   ========================================================= */
(function () {
  'use strict';

  if (window.__astroyaTddBoot) { return; }
  window.__astroyaTddBoot = true;

  /* ---------- DONNEES ---------- */
  var DOM = ['Amour', 'Travail', 'Argent', 'Sant\u00e9', 'Famille', 'Projet',
             'D\u00e9cision', 'Blocage', 'Amiti\u00e9', 'Maison', 'Voyage', 'Soi'];
  var ENE = ['Avance', 'Attends', 'Coupe', 'Ouvre', 'R\u00e9pare', 'Ose'];
  var TIM = ['Aujourd\u2019hui', 'Cette semaine', 'Ce mois-ci', 'Sous 3 jours',
             'Apr\u00e8s un signe', 'D\u00e9j\u00e0 l\u00e0'];
  var YESNO = ['Oui', 'Non', 'Oui, fonce', 'Non, pas \u00e7a',
               'Pas maintenant', 'Redemande demain'];

  var YN_TXT = {
    'Oui': 'La voie est ouverte. Ta question portait d\u00e9j\u00e0 sa r\u00e9ponse \u2014 il ne te manquait que la permission.',
    'Non': 'Ce n\u2019est pas la bonne porte. Refuser maintenant t\u2019\u00e9vite de r\u00e9parer plus tard.',
    'Oui, fonce': 'Non seulement c\u2019est oui, mais la fen\u00eatre est courte. L\u2019h\u00e9sitation co\u00fbterait plus cher que l\u2019erreur.',
    'Non, pas \u00e7a': 'Le fond est bon, la forme ne l\u2019est pas. Reformule ton projet avant de le repr\u00e9senter.',
    'Pas maintenant': 'La r\u00e9ponse n\u2019est pas non \u2014 elle est \u00ab\u00a0pas encore\u00a0\u00bb. Un \u00e9l\u00e9ment doit d\u2019abord bouger.',
    'Redemande demain': 'La situation est encore en mouvement. Laisse passer une nuit\u00a0: la question aura m\u00fbri.'
  };

  var PH = {
    'Travail|Coupe': 'Une t\u00e2che que tu tra\u00eenes te vole plus d\u2019\u00e9nergie qu\u2019elle ne t\u2019en rapporte. Retire-la de ta liste.',
    'Amour|Ose': 'Tu attends que l\u2019autre fasse le premier pas. Il attend la m\u00eame chose.',
    'Argent|R\u00e9pare': 'Une fuite discr\u00e8te vide ton compte depuis des mois. Regarde tes pr\u00e9l\u00e8vements.',
    'D\u00e9cision|Attends': 'Tu as toutes les informations sauf une. Ne tranche pas avant de l\u2019avoir.',
    'Sant\u00e9|Coupe': 'Ton corps envoie un signal que tu ranges dans \u00ab\u00a0plus tard\u00a0\u00bb depuis trop longtemps.',
    'Blocage|Ose': 'Ce qui te bloque n\u2019est pas la situation, c\u2019est la peur de la nommer \u00e0 voix haute.'
  };

  /* phrase-action gratuite pour les 66 combinaisons sans texte dedie (tableau des energies de la page) */
  var ENE_TXT = {
    'Avance': 'le moment est favorable\u00a0: fais le premier pas, m\u00eame petit, sans attendre les conditions parfaites.',
    'Attends': 'il manque une pi\u00e8ce au puzzle. Patienter n\u2019est pas fuir\u00a0: c\u2019est laisser la situation se r\u00e9v\u00e9ler.',
    'Coupe': 'quelque chose te co\u00fbte plus qu\u2019il ne t\u2019apporte. Retire-le, sans le remplacer tout de suite.',
    'Ouvre': 'accepte ce qui se pr\u00e9sente\u00a0: invitation, proposition, id\u00e9e nouvelle, m\u00eame inconfortable.',
    'R\u00e9pare': 'un d\u00e9tail n\u00e9glig\u00e9 s\u2019aggrave en silence. Une seule r\u00e9paration aujourd\u2019hui suffit.',
    'Ose': 'le risque que tu redoutes est plus petit que le regret qui t\u2019attend. Lance-toi.'
  };
  function freePhrase(d, e) {
    var who = (d === 'Soi') ? 'toi-m\u00eame' : d.toLowerCase();
    return 'C\u00f4t\u00e9 ' + who + ', ' + (ENE_TXT[e] || '');
  }

  /* ---------- n8n : interpretation detaillee + inscription a la newsletter ----------
     Aucune cle ni liste Klaviyo ici. Les des, la phrase-action et le mode Oui/Non restent dans la page. */
  var API = 'https://n8n.astroya.fr/webhook/tirage-des';
  /* MODE STRICT : l'interpretation detaillee est reservee aux personnes inscrites via la popup de CETTE page.
     A l'inscription, n8n remet un JETON SIGNE. Email + jeton gardes 2 fois : localStorage + cookie astroya.fr. */
  var K_EMAIL = 'astroya_tdd_email', K_TOKEN = 'astroya_tdd_token', COOKIE_DAYS = 400;
  /* emails d'autres outils Astroya : servent UNIQUEMENT a pre-remplir la popup */
  var PREFILL_KEYS = ['astroya_rnt_email', 'astroya_runes_email', 'astroya_lnd_email', 'astroya_ttm_email', 'astroya_tarologie_email', 'astroya_t3c_email', 'astroya_bel_email', 'astroya_ral_email', 'astroya_newsletter_email', 'astroya_amour_email_v2', 'astroya_boule_email_v2', 'astroya_pendule_email_v2', 'astroya_tarot_oui_non_email_v2'];

  function cookieGet(k) {
    try {
      var parts = document.cookie ? document.cookie.split('; ') : [];
      for (var i = 0; i < parts.length; i++) { var p = parts[i].split('='); if (p[0] === k) { return decodeURIComponent(p.slice(1).join('=')); } }
    } catch (e) { /* */ }
    return '';
  }
  function cookieSet(k, v) {
    try {
      var dom = /(^|\.)astroya\.fr$/.test(location.hostname) ? '; domain=.astroya.fr' : '';
      var dt = new Date(); dt.setTime(dt.getTime() + COOKIE_DAYS * 864e5);
      document.cookie = k + '=' + encodeURIComponent(v) + '; expires=' + dt.toUTCString() + '; path=/' + dom + '; SameSite=Lax' + (location.protocol === 'https:' ? '; Secure' : '');
    } catch (e) { /* */ }
  }
  function lsGet(k) { try { return window.localStorage.getItem(k) || ''; } catch (e) { return ''; } }
  function lsSet(k, v) { try { window.localStorage.setItem(k, v); } catch (e) { /* */ } }
  function store(k, v) { if (v) { lsSet(k, v); cookieSet(k, v); } }
  function readKey(k) {
    var v = lsGet(k) || cookieGet(k);
    if (v) { if (!lsGet(k)) { lsSet(k, v); } if (!cookieGet(k)) { cookieSet(k, v); } }
    return v;
  }
  function getAuth() { return { email: readKey(K_EMAIL), token: readKey(K_TOKEN) }; }
  function saveAuth(email, token) { store(K_EMAIL, email); store(K_TOKEN, token); }
  function knownEmail() {
    var a = getAuth(); if (a.email) { return a.email; }
    for (var i = 0; i < PREFILL_KEYS.length; i++) { var v = lsGet(PREFILL_KEYS[i]); if (v) { return v; } }
    return '';
  }
  function ask(payload) {
    var ctrl = (typeof AbortController !== 'undefined') ? new AbortController() : null;
    var timer = ctrl ? window.setTimeout(function () { ctrl.abort(); }, 15000) : null;
    return window.fetch(API, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload), signal: ctrl ? ctrl.signal : undefined })
      .then(function (r) { if (!r.ok) { throw new Error('http ' + r.status); } return r.json(); })
      .then(function (d) {
        if (timer) { window.clearTimeout(timer); }
        var data = (d && d.length) ? d[0] : d;
        if (!data || data.ok !== true) { var er = new Error('refus'); er.code = (data && data.error) || ''; throw er; }
        return data;
      })['catch'](function (err) { if (timer) { window.clearTimeout(timer); } throw err; });
  }

  /* ---------- STYLES INJECTES : popup + interpretation ----------
     Poses par le JS lui-meme : rien a coller dans le CSS d'EComposer, rien ne peut manquer. */
  var CSS = ''
    + '.tdd-dx{margin:0 0 14px !important;padding:22px 24px !important;border-radius:18px !important;background:rgba(255,255,255,.05) !important;border:1px solid rgba(255,255,255,.11) !important;animation:tddmIn .6s ease-out}'
    + '.tdd-dx p{font-family:Arial,Helvetica,sans-serif !important;font-size:16px !important;line-height:1.7 !important;color:rgba(255,244,232,.85) !important;margin:0 0 10px !important}'
    + '.tdd-dx p:last-child{margin:0 !important}.tdd-dx b{color:#FFF4E8 !important}'
    + '.tdd-lock{text-align:center !important;padding:28px 24px !important;border-radius:22px !important;background:linear-gradient(135deg,rgba(123,47,247,.22),rgba(247,37,133,.14)) !important;border:1px solid rgba(255,255,255,.18) !important;animation:tddmIn .6s ease-out}'
    + '.tdd-lock p{font-family:Arial,Helvetica,sans-serif !important;font-size:16px !important;line-height:1.7 !important;color:rgba(255,244,232,.85) !important;margin:0 auto 18px !important;max-width:520px !important}'
    + '.tdd-lock p.tdd-lock-note{font-size:13px !important;color:rgba(255,244,232,.55) !important;margin:12px auto 0 !important}'
    + '.tdd-lock-btn{display:inline-block !important;padding:16px 36px !important;border:none !important;border-radius:100px !important;cursor:pointer !important;font-family:Arial,Helvetica,sans-serif !important;font-weight:700 !important;font-size:16px !important;letter-spacing:.06em !important;text-transform:none !important;color:#fff !important;background:linear-gradient(100deg,#7B2FF7,#F72585,#FF5E5B) !important;box-shadow:0 12px 36px rgba(247,37,133,.5) !important;transition:transform .25s !important}'
    + '.tdd-lock-btn:hover{transform:translateY(-2px) scale(1.03) !important}'
    + '@keyframes tddmIn{from{opacity:0;transform:translateY(12px)}to{opacity:1;transform:none} }'
    + '.tddm-modal{position:fixed !important;inset:0 !important;z-index:100001 !important;display:none !important;align-items:center !important;justify-content:center !important;padding:16px !important;box-sizing:border-box !important;max-width:none !important;margin:0 !important}'
    + '.tddm-modal.tddm-open{display:flex !important}.tddm-modal *{box-sizing:border-box !important}'
    + '.tddm-overlay{position:absolute !important;inset:0 !important;background:rgba(10,4,20,.82) !important;font-size:0 !important}'
    + '.tddm-box{position:relative !important;z-index:1 !important;width:100% !important;max-width:400px !important;max-height:94vh !important;overflow-y:auto !important;background:radial-gradient(circle at 85% 12%,rgba(123,47,247,.45),transparent 55%),radial-gradient(circle at 10% 90%,rgba(247,37,133,.3),transparent 55%),#180a2b !important;border:1px solid rgba(255,255,255,.2) !important;border-radius:22px !important;padding:26px 22px 20px !important;text-align:center !important;box-shadow:0 30px 80px rgba(0,0,0,.6),0 0 50px rgba(123,47,247,.3) !important;animation:tddmIn .35s ease-out}'
    + '.tddm-step{display:flex !important;flex-direction:column !important;gap:8px !important}.tddm-step[hidden]{display:none !important}'
    + '.tddm-close{position:absolute !important;top:10px !important;right:10px !important;width:36px !important;height:36px !important;padding:0 !important;border:1px solid rgba(255,255,255,.25) !important;border-radius:50% !important;background:rgba(255,255,255,.08) !important;color:#FFF4E8 !important;font-size:22px !important;line-height:1 !important;cursor:pointer !important}'
    + '.tddm-title{font-family:"El Messiri",Georgia,serif !important;font-size:24px !important;font-weight:700 !important;line-height:1.25 !important;margin:0 !important;padding:0 40px !important;background:linear-gradient(100deg,#FFB627,#FF5E5B,#F72585) !important;-webkit-background-clip:text !important;background-clip:text !important;-webkit-text-fill-color:transparent !important;color:transparent !important}'
    + '.tddm-text{font-family:Arial,Helvetica,sans-serif !important;font-size:15px !important;line-height:1.5 !important;color:rgba(255,244,232,.75) !important;margin:0 0 6px !important}'
    + '.tddm-field{width:100% !important;min-height:44px !important;padding:10px 14px !important;margin:0 !important;font-family:Arial,Helvetica,sans-serif !important;font-size:16px !important;text-align:center !important;color:#FFF4E8 !important;background:rgba(255,255,255,.08) !important;border:1px solid rgba(255,255,255,.25) !important;border-radius:100px !important;-webkit-appearance:none !important;appearance:none !important;outline:none !important}'
    + '.tddm-field:focus{border-color:#25E5C4 !important;box-shadow:0 0 0 3px rgba(37,229,196,.2) !important}.tddm-field::placeholder{color:rgba(255,244,232,.45) !important}'
    + '.tddm-consent{display:flex !important;align-items:flex-start !important;gap:10px !important;padding:9px 11px !important;text-align:left !important;cursor:pointer !important;background:rgba(255,255,255,.06) !important;border:1px solid rgba(255,255,255,.2) !important;border-radius:12px !important;margin:0 !important}'
    + '.tddm-consent input{flex-shrink:0 !important;width:18px !important;height:18px !important;margin:1px 0 0 !important;accent-color:#F72585 !important;cursor:pointer !important}'
    + '.tddm-consent span{font-family:Arial,Helvetica,sans-serif !important;font-size:14px !important;line-height:1.45 !important;color:rgba(255,244,232,.88) !important}'
    + '.tddm-consent.tddm-invalid{border-color:#FF5E5B !important;box-shadow:0 0 0 3px rgba(255,94,91,.25) !important}'
    + '.tddm-btn{width:100% !important;margin:2px 0 0 !important;padding:14px 18px !important;border:none !important;border-radius:100px !important;cursor:pointer !important;font-family:Arial,Helvetica,sans-serif !important;font-size:16px !important;font-weight:700 !important;line-height:1.3 !important;letter-spacing:.04em !important;text-transform:none !important;color:#fff !important;background:linear-gradient(100deg,#7B2FF7,#F72585,#FF5E5B) !important;box-shadow:0 10px 30px rgba(247,37,133,.45) !important}'
    + '.tddm-btn:disabled{opacity:.6 !important;cursor:wait !important}'
    + '.tddm-error{display:none !important;font-family:Arial,Helvetica,sans-serif !important;font-size:13.5px !important;line-height:1.45 !important;color:#FF8A87 !important;margin:0 !important}.tddm-error.tddm-show{display:block !important}'
    + '.tddm-legal{font-family:Arial,Helvetica,sans-serif !important;font-size:11.5px !important;color:rgba(255,244,232,.5) !important;margin:2px 0 0 !important;line-height:1.45 !important}.tddm-legal a{color:#25E5C4 !important;text-decoration:underline !important}'
    + '.tddm-astral{background:rgba(255,255,255,.07) !important;border:1px solid rgba(255,182,39,.4) !important;border-radius:16px !important;padding:14px !important;margin:2px 0 4px !important}'
    + '.tddm-astral-h{font-family:Arial,Helvetica,sans-serif !important;font-size:15.5px !important;font-weight:700 !important;line-height:1.4 !important;color:#FFF4E8 !important;margin:0 0 10px !important}'
    + '.tddm-astral-cta{display:block !important;padding:12px 16px !important;border-radius:100px !important;text-decoration:none !important;text-align:center !important;font-family:Arial,Helvetica,sans-serif !important;font-size:16px !important;font-weight:700 !important;color:#3A1F00 !important;background:linear-gradient(135deg,#FFE29B,#FFB627) !important;box-shadow:0 8px 22px rgba(255,182,39,.35) !important}'
    + 'body.tddm-lock{overflow:hidden !important}'
    + '@media (max-width:767px){.tdd-dx p,.tdd-lock p{font-size:15px !important}.tdd-lock-btn{width:100% !important;font-size:15px !important;padding:15px 18px !important}.tddm-title{font-size:21px !important}.tddm-text{font-size:14px !important}.tddm-btn{font-size:15px !important} }'
    + '@media (max-height:640px){.tddm-box{padding:18px 16px 14px !important}.tddm-field{min-height:40px !important;padding:8px 12px !important} }';
  function injectCss() {
    if (id('tdd-mstyle')) { return; }
    var st = document.createElement('style'); st.id = 'tdd-mstyle'; st.appendChild(document.createTextNode(CSS));
    (document.head || document.documentElement).appendChild(st);
  }

  /* ---------- INTERPRETATION DETAILLEE (n8n, inscrits via cette page) ---------- */
  var lastDraw = null, drawId = 0, sending = false;
  function setTxt(x, v) { var el = id(x); if (el) { el.textContent = v; } }
  function showEl(x, disp) { var el = id(x); if (el) { el.style.setProperty('display', disp, 'important'); } }
  function escapeHtml(v) { return String(v).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); }
  function hideDeep() { showEl('tdd-dx', 'none'); showEl('tdd-bl', 'none'); showEl('tdd-lock', 'none'); }
  function lockDeep() { showEl('tdd-dx', 'none'); showEl('tdd-bl', 'none'); showEl('tdd-lock', 'block'); }
  function renderDeep(r) {
    var d1 = id('tdd-dx1'), d2 = id('tdd-dx2');
    if (d1) { d1.innerHTML = '<b>' + escapeHtml(r.domaineTitre) + '.</b> ' + escapeHtml(r.domaine); }
    if (d2) { d2.innerHTML = '<b>' + escapeHtml(r.momentTitre) + '.</b> ' + escapeHtml(r.moment); }
    setTxt('tdd-b1', r.geste); setTxt('tdd-b2', r.question); setTxt('tdd-b3', r.eviter);
    showEl('tdd-lock', 'none'); showEl('tdd-dx', 'block'); showEl('tdd-bl', 'grid');
    var bl = id('tdd-bl'); if (bl) { bl.classList.add('tdd-in'); }
  }
  /* inscrit via cette page : l'interpretation s'affiche d'elle-meme, sans popup */
  function showDeep() {
    drawId++;
    var auth = getAuth(), my = drawId;
    lockDeep();
    if (!auth.email || !lastDraw) { return; }
    ask({ action: 'reveal', ids: lastDraw, email: auth.email, token: auth.token }).then(function (r) {
      if (my !== drawId) { return; }
      saveAuth(auth.email, r.token || auth.token);
      renderDeep(r);
    }, function () { /* pas (encore) inscrit via cette page : reste verrouillee, rien n'est efface */ });
  }

  /* ---------- POPUP EMAIL : 2 ECRANS SUCCESSIFS ---------- */
  function popStep(n) { var f = id('tddm-form'), sc = id('tddm-ok'); if (f) { f.hidden = (n !== 1); } if (sc) { sc.hidden = (n !== 2); } }
  function popError(msg) {
    var e = id('tddm-err'); if (!e) { return; }
    if (!msg) { e.classList.remove('tddm-show'); e.innerHTML = '&#8203;'; return; }
    e.textContent = msg; e.classList.add('tddm-show');
  }
  function openPop() {
    var m = id('tddm'); if (!m) { return; }
    popStep(1); popError('');
    var em = id('tddm-email'); if (em && !em.value) { em.value = knownEmail(); }
    m.classList.add('tddm-open'); m.setAttribute('aria-hidden', 'false');
    document.body.classList.add('tddm-lock');
    if (window.innerWidth > 700) { window.setTimeout(function () { var i = id('tddm-email'); if (i) { i.focus(); } }, 200); }
  }
  function closePop() {
    var m = id('tddm'); if (!m) { return; }
    m.classList.remove('tddm-open'); m.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('tddm-lock');
  }
  function submitPop() {
    if (sending) { return; }
    var emEl = id('tddm-email'), cb = id('tddm-consent'), btn = id('tddm-submit');
    var email = emEl ? (emEl.value || '').trim().toLowerCase() : '';
    if (!/^[^\s@"\\]+@([a-z0-9]([a-z0-9-]*[a-z0-9])?\.)+[a-z]{2,}$/i.test(email)) { popError('Cette adresse e-mail semble incorrecte. V\u00e9rifie-la et r\u00e9essaie.'); if (emEl) { emEl.focus(); } return; }
    if (!cb || !cb.checked) {
      popError('Coche la case pour recevoir ton interpr\u00e9tation d\u00e9taill\u00e9e.');
      var lab = document.querySelector('#tddm .tddm-consent');
      if (lab) { lab.classList.add('tddm-invalid'); window.setTimeout(function () { lab.classList.remove('tddm-invalid'); }, 600); }
      return;
    }
    popError(''); sending = true;
    if (btn) { btn.disabled = true; btn.textContent = 'Envoi\u2026'; }
    function restore() { sending = false; if (btn) { btn.disabled = false; btn.textContent = 'Recevoir mon interpr\u00e9tation'; } }
    var my = drawId;
    /* un seul appel : n8n inscrit a la newsletter et renvoie l'interpretation */
    ask({ action: 'subscribe', email: email, consent: true, ids: lastDraw }).then(function (r) {
      saveAuth(email, r.token);
      if (r.domaine && my === drawId) { renderDeep(r); }
      popStep(2); restore();
    }, function (err) {
      var c = err && err.code;
      popError(c === 'email' ? 'Cette adresse e-mail semble incorrecte. V\u00e9rifie-la et r\u00e9essaie.'
        : c === 'klaviyo' ? 'L\u2019inscription n\u2019a pas pu aboutir. R\u00e9essaie dans un instant.'
        : 'Connexion interrompue. V\u00e9rifie ton r\u00e9seau et r\u00e9essaie.');
      restore();
    });
  }

  /* orientation a appliquer pour amener chaque face vers l'avant */
  var TARGETS = [
    { x: 0, y: 0 },     /* front  */
    { x: 0, y: 180 },   /* back   */
    { x: 0, y: -90 },   /* right  */
    { x: 0, y: 90 },    /* left   */
    { x: -90, y: 0 },   /* top    */
    { x: 90, y: 0 }     /* bottom */
  ];
  var COLORS = ['#7B2FF7', '#F72585', '#FF5E5B', '#FFB627', '#25E5C4', '#9B6BFF'];
  var MAX_ROLLS = 3;
  var LS_KEY = 'astroya_tdd_rolls';

  /* ---------- ETAT ---------- */
  var left = MAX_ROLLS;
  var busy = false;
  var mode3 = true;
  var muted = false;
  var spins = [{ x: 0, y: 0, z: 0 }, { x: 0, y: 0, z: 0 }, { x: 0, y: 0, z: 0 }];

  function id(x) { return document.getElementById(x); }

  /* ---------- QUOTA JOURNALIER ---------- */
  function today() {
    var d = new Date();
    return d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate();
  }
  function loadQuota() {
    try {
      var raw = window.localStorage.getItem(LS_KEY);
      if (!raw) { return MAX_ROLLS; }
      var o = JSON.parse(raw);
      if (o.day !== today()) { return MAX_ROLLS; }
      return Math.max(0, MAX_ROLLS - (o.used || 0));
    } catch (e) { return MAX_ROLLS; }
  }
  function saveQuota() {
    try {
      window.localStorage.setItem(LS_KEY, JSON.stringify({
        day: today(),
        used: MAX_ROLLS - left
      }));
    } catch (e) { /* mode prive : on ignore */ }
  }

  /* ---------- SON (WebAudio, synthese pure) ----------
     Direction : feutre et bien-etre.
     - impacts : bois sourd, filtre passe-bas, pas de claquement sec
     - carillon : gamme pentatonique majeure (do-re-mi-sol-la),
       la gamme des carillons zen : aucun intervalle dissonant possible
     - une legere reverb (convolution) enveloppe le tout            */

  var AC = null;
  var MASTER = null;
  var REVERB = null;

  function actx() {
    if (muted) { return null; }
    var C = window.AudioContext || window.webkitAudioContext;
    if (!C) { return null; }
    if (!AC) {
      AC = new C();
      /* bus master : garde le volume general doux */
      MASTER = AC.createGain();
      MASTER.gain.value = 0.4;
      MASTER.connect(AC.destination);
      /* reverb : queue courte et douce, donne de l'air aux sons */
      REVERB = AC.createConvolver();
      var dur = 1.6;
      var len = Math.floor(AC.sampleRate * dur);
      var imp = AC.createBuffer(2, len, AC.sampleRate);
      var ch, dat, i;
      for (ch = 0; ch < 2; ch++) {
        dat = imp.getChannelData(ch);
        for (i = 0; i < len; i++) {
          dat[i] = (Math.random() * 2 - 1) * Math.pow(1 - i / len, 2.6);
        }
      }
      REVERB.buffer = imp;
      var wet = AC.createGain();
      wet.gain.value = 0.22;
      REVERB.connect(wet);
      wet.connect(MASTER);
    }
    if (AC.state === 'suspended') { AC.resume(); }
    return AC;
  }

  /* route un noeud vers le master (sec) + la reverb (humide) */
  function route(node, wetAmount) {
    if (!MASTER) { return; }
    node.connect(MASTER);
    if (REVERB) {
      var send = AC.createGain();
      send.gain.value = (wetAmount === undefined) ? 0.35 : wetAmount;
      node.connect(send);
      send.connect(REVERB);
    }
  }

  /* impact feutre : sinus grave + souffle filtre, aucune attaque dure */
  function thud(vol, fr) {
    var a = actx();
    if (!a) { return; }
    var t = a.currentTime;

    /* corps : sinus (rond) plutot que triangle (mordant) */
    var o = a.createOscillator();
    var g = a.createGain();
    o.type = 'sine';
    o.frequency.setValueAtTime(fr, t);
    o.frequency.exponentialRampToValueAtTime(fr * 0.55, t + 0.18);
    /* attaque adoucie : 12 ms de fondu au lieu d'un pic instantane */
    g.gain.setValueAtTime(0.0001, t);
    g.gain.linearRampToValueAtTime(vol, t + 0.012);
    g.gain.exponentialRampToValueAtTime(0.001, t + 0.26);
    o.connect(g);
    route(g, 0.3);
    o.start(t);
    o.stop(t + 0.3);

    /* souffle : bruit passe-bas, evoque le bois sur le feutre */
    var len = Math.floor(a.sampleRate * 0.05);
    var b = a.createBuffer(1, len, a.sampleRate);
    var d = b.getChannelData(0);
    var i;
    for (i = 0; i < len; i++) {
      d[i] = (Math.random() * 2 - 1) * Math.pow(1 - i / len, 2);
    }
    var src = a.createBufferSource();
    src.buffer = b;
    var lp = a.createBiquadFilter();
    lp.type = 'lowpass';
    lp.frequency.value = 900;
    lp.Q.value = 0.7;
    var g2 = a.createGain();
    g2.gain.setValueAtTime(0.0001, t);
    g2.gain.linearRampToValueAtTime(vol * 0.3, t + 0.008);
    g2.gain.exponentialRampToValueAtTime(0.001, t + 0.09);
    src.connect(lp);
    lp.connect(g2);
    route(g2, 0.2);
    src.start(t);
  }

  /* cliquetis des des dans la main : plus rare, plus doux, plus grave */
  function rattle() {
    if (!actx()) { return; }
    var i;
    for (i = 0; i < 7; i++) {
      (function (k) {
        window.setTimeout(function () {
          thud(0.05 + Math.random() * 0.04, 240 + Math.random() * 260);
        }, k * 58 + Math.random() * 34);
      }(i));
    }
  }

  /* rebonds : volumes reduits, plus graves, decroissance naturelle */
  function bounceSounds(delay, dur) {
    var pts = [0.38, 0.66, 0.86];
    var vols = [0.3, 0.17, 0.09];
    var i;
    for (i = 0; i < 3; i++) {
      (function (p, v) {
        window.setTimeout(function () {
          thud(v, 95 + Math.random() * 40);
        }, delay + dur * p);
      }(pts[i], vols[i]));
    }
  }

  /* une note de carillon, version douce.
     Partiels legerement inharmoniques (assez pour le timbre cristal,
     pas assez pour le cote metallique/gong), aigus discrets et vite
     eteints, attaque en fondu de 50 ms : le tube est effleure.       */
  function bell(freq, when, vol) {
    var a = actx();
    if (!a) { return; }
    var t = a.currentTime + when;

    var parts = [
      { r: 1.00, v: 1.00, d: 2.10 },
      { r: 2.40, v: 0.16, d: 1.00 },
      { r: 4.20, v: 0.05, d: 0.45 }
    ];
    var i, o, g, pa;

    for (i = 0; i < parts.length; i++) {
      pa = parts[i];
      o = a.createOscillator();
      g = a.createGain();
      o.type = 'sine';
      o.frequency.value = freq * pa.r;
      g.gain.setValueAtTime(0.0001, t);
      g.gain.linearRampToValueAtTime(vol * pa.v, t + 0.05);
      g.gain.exponentialRampToValueAtTime(0.0001, t + pa.d);
      o.connect(g);
      route(g, 0.5);
      o.start(t);
      o.stop(t + pa.d + 0.1);
    }
  }

  /* carillon de revelation, version douce.
     Pentatonique majeure (do-re-mi-sol-la) : aucun intervalle tendu.
     4 notes seulement, tirees au sort, espacements irreguliers.
     Pas de bol chantant, pas de bourdon : juste quelques tubes
     qui s'effleurent.                                               */
  function chime() {
    var a = actx();
    if (!a) { return; }

    var scale = [
      587.33,  /* re5  */
      659.25,  /* mi5  */
      783.99,  /* sol5 */
      880.00,  /* la5  */
      1046.50, /* do6  */
      1174.66  /* re6  */
    ];

    var picked = [];
    var i, n, when, vol;
    when = 0.04;

    for (i = 0; i < 4; i++) {
      do {
        n = scale[Math.floor(Math.random() * scale.length)];
      } while (picked.length && n === picked[picked.length - 1]);
      picked.push(n);

      vol = 0.06 - (i * 0.006) + (Math.random() * 0.012);
      if (vol < 0.028) { vol = 0.028; }

      bell(n, when, vol);
      when += 0.09 + Math.random() * 0.11;
    }
  }

  /* ---------- UTILITAIRES ---------- */
  function shuffle(a) {
    var arr = a.slice();
    var i, j, t;
    for (i = arr.length - 1; i > 0; i--) {
      j = Math.floor(Math.random() * (i + 1));
      t = arr[i]; arr[i] = arr[j]; arr[j] = t;
    }
    return arr;
  }
  function fillFaces(cube, values) {
    var faces = cube.querySelectorAll('.tdd-face');
    var i;
    for (i = 0; i < 6; i++) {
      if (faces[i]) { faces[i].textContent = values[i]; }
    }
  }
  function confetti() {
    var box = id('tdd-cfx');
    if (!box) { return; }
    box.innerHTML = '';
    var i, c;
    for (i = 0; i < 46; i++) {
      c = document.createElement('div');
      c.className = 'tdd-cf';
      c.style.left = (Math.random() * 100) + '%';
      c.style.background = COLORS[i % COLORS.length];
      c.style.animationDelay = (Math.random() * 0.5) + 's';
      box.appendChild(c);
    }
    window.setTimeout(function () { box.innerHTML = '\u200B'; }, 2400);
  }

  /* ---------- LANCER D'UN DE ---------- */
  function rollOne(idx, pool, dur) {
    var die = id('tdd-d' + idx);
    var cube = id('tdd-cb' + idx);
    if (!die || !cube) { return ''; }

    var vals = shuffle(pool).slice(0, 6);
    fillFaces(cube, vals);

    var f = Math.floor(Math.random() * 6);
    var t = TARGETS[f];

    /* les rotations s'accumulent : le de repart toujours vers l'avant,
       jamais de retour arriere entre deux lancers */
    spins[idx].x += 360 * (3 + Math.floor(Math.random() * 3));
    spins[idx].y += 360 * (3 + Math.floor(Math.random() * 3));
    spins[idx].z += 360 * (1 + Math.floor(Math.random() * 2));

    die.classList.remove('tdd-landed');
    die.classList.add('tdd-rolling');

    /* la duree de transition est posee en inline : le CSS decompose
       transition-property/timing pour ne pas bloquer cette assignation */
    cube.style.setProperty('transition-duration', dur + 'ms', 'important');
    cube.style.transform = 'rotateX(' + (spins[idx].x + t.x) + 'deg) rotateY(' +
                           (spins[idx].y + t.y) + 'deg) rotateZ(' + spins[idx].z + 'deg)';

    window.setTimeout(function () {
      die.classList.remove('tdd-rolling');
      die.classList.add('tdd-landed');
    }, dur);

    return vals[f];
  }

  /* ---------- FIN DE TIRAGE ---------- */
  function finish() {
    var ring = id('tdd-ring');
    if (ring) {
      ring.classList.add('tdd-hit');
      window.setTimeout(function () { ring.classList.remove('tdd-hit'); }, 900);
    }
    chime();
    confetti();
    if (navigator.vibrate) { navigator.vibrate(80); }

    var res = id('tdd-res');
    if (res) {
      res.classList.add('tdd-show');
      window.setTimeout(function () {
        var ph = id('tdd-ph');
        var bl = id('tdd-bl');
        if (ph) { ph.classList.add('tdd-in'); }
        if (bl) { bl.classList.add('tdd-in'); }
      }, 60);
      try { res.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
      catch (e) { res.scrollIntoView(); }
    }

    left--;
    saveQuota();
    var ct = id('tdd-ct');
    if (ct) { ct.textContent = left; }
    if (left <= 0) {
      var go = id('tdd-go');
      if (go) {
        go.disabled = true;
        go.textContent = 'Reviens demain';
      }
    }
    busy = false;
  }

  /* ---------- LANCER ---------- */
  function roll() {
    if (busy || left <= 0) { return; }
    busy = true;

    var res = id('tdd-res');
    var ph = id('tdd-ph');
    var bl = id('tdd-bl');
    var vd = id('tdd-vd');
    var combo = id('tdd-combo');
    if (res) { res.classList.remove('tdd-show'); }
    if (ph) { ph.classList.remove('tdd-in'); }
    if (bl) { bl.classList.remove('tdd-in'); }
    if (vd) { vd.classList.remove('tdd-show'); }

    if (navigator.vibrate) { navigator.vibrate([40, 60, 40, 60, 120]); }
    rattle();

    if (mode3) {
      bounceSounds(0, 2300);
      bounceSounds(180, 2650);
      bounceSounds(360, 3000);

      var d = rollOne(0, DOM, 2300);
      var e = '';
      var t = '';

      window.setTimeout(function () { e = rollOne(1, ENE, 2650); }, 180);
      window.setTimeout(function () { t = rollOne(2, TIM, 3000); }, 360);

      window.setTimeout(function () {
        if (combo) { combo.style.display = 'block'; }
        var c1 = id('tdd-c1'), c2 = id('tdd-c2'), c3 = id('tdd-c3');
        if (c1) { c1.textContent = d; }
        if (c2) { c2.textContent = e; }
        if (c3) { c3.textContent = t; }

        var key = d + '|' + e;
        var pt = id('tdd-pt');
        if (pt) {
          pt.textContent = PH[key] || freePhrase(d, e);
        }
        lastDraw = [DOM.indexOf(d), ENE.indexOf(e), TIM.indexOf(t)];
        showDeep();

        finish();
      }, 3500);

    } else {
      bounceSounds(0, 2800);
      var v = rollOne(1, YESNO, 2800);

      window.setTimeout(function () {
        if (vd) {
          vd.textContent = v;
          vd.classList.add('tdd-show');
        }
        if (combo) { combo.style.display = 'none'; }
        var pt2 = id('tdd-pt');
        if (pt2) { pt2.textContent = YN_TXT[v] || ''; }
        drawId++; lastDraw = null; hideDeep();

        finish();
      }, 3000);
    }
  }

  /* ---------- CHANGEMENT DE MODE ---------- */
  function setMode(three) {
    if (busy) { return; }
    mode3 = three;

    var m3 = id('tdd-m3'), m1 = id('tdd-m1');
    var d0 = id('tdd-d0'), d2 = id('tdd-d2');
    var tg1 = id('tdd-tg1'), tg2 = id('tdd-tg2'), tg3 = id('tdd-tg3');
    var res = id('tdd-res');
    var cb1 = id('tdd-cb1');

    if (m3) { if (three) { m3.classList.add('tdd-on'); } else { m3.classList.remove('tdd-on'); } }
    if (m1) { if (three) { m1.classList.remove('tdd-on'); } else { m1.classList.add('tdd-on'); } }
    if (d0) { if (three) { d0.classList.remove('tdd-off'); } else { d0.classList.add('tdd-off'); } }
    if (d2) { if (three) { d2.classList.remove('tdd-off'); } else { d2.classList.add('tdd-off'); } }
    if (tg1) { if (three) { tg1.classList.remove('tdd-off'); } else { tg1.classList.add('tdd-off'); } }
    if (tg3) { if (three) { tg3.classList.remove('tdd-off'); } else { tg3.classList.add('tdd-off'); } }
    if (tg2) { tg2.textContent = three ? '\u00c9nergie' : 'R\u00e9ponse'; }
    if (res) { res.classList.remove('tdd-show'); }
    if (cb1) { fillFaces(cb1, three ? shuffle(ENE) : shuffle(YESNO)); }
  }

  /* ---------- BOOT ---------- */
  function boot() {
    var go = id('tdd-go');
    var cb0 = id('tdd-cb0');
    if (!go || !cb0) { return false; }
    if (go.getAttribute('data-tdd-ready') === '1') { return true; }
    go.setAttribute('data-tdd-ready', '1');

    injectCss();
    /* popup placee dans <body> : position:fixed fiable (le CSS de la page force position:relative sur ses enfants) */
    var pm = id('tddm');
    if (pm && pm.parentNode !== document.body) { document.body.appendChild(pm); }

    /* faces au repos */
    fillFaces(cb0, shuffle(DOM).slice(0, 6));
    var cb1 = id('tdd-cb1');
    var cb2 = id('tdd-cb2');
    if (cb1) { fillFaces(cb1, shuffle(ENE)); }
    if (cb2) { fillFaces(cb2, shuffle(TIM)); }

    /* quota du jour */
    left = loadQuota();
    var ct = id('tdd-ct');
    if (ct) { ct.textContent = left; }
    if (left <= 0) {
      go.disabled = true;
      go.textContent = 'Reviens demain';
    }
    return true;
  }

  /* delegation au niveau document : survit aux re-rendus EComposer */
  document.addEventListener('click', function (ev) {
    var t = ev.target;
    if (!t || !t.closest) { return; }

    if (t.closest('#tdd-deep-btn')) { openPop(); return; }
    if (t.closest('#tddm-close') || t.closest('#tddm-overlay')) { closePop(); return; }
    if (t.closest('#tddm-submit')) { ev.preventDefault(); submitPop(); return; }
    if (t.closest('#tddm-continue')) {
      closePop();
      try { var dx = id('tdd-dx'); if (dx) { dx.scrollIntoView({ behavior: 'smooth', block: 'center' }); } } catch (e) { /* */ }
      return;
    }

    if (t.closest('#tdd-go')) { roll(); return; }
    if (t.closest('#tdd-m3')) { setMode(true); return; }
    if (t.closest('#tdd-m1')) { setMode(false); return; }

    var snd = t.closest('#tdd-snd');
    if (snd) {
      muted = !muted;
      snd.innerHTML = muted ? '\uD83D\uDD07' : '\uD83D\uDD0A';
      if (muted) { snd.classList.add('tdd-mute'); }
      else { snd.classList.remove('tdd-mute'); }
      /* coupe aussi les sons deja programmes dans le futur */
      if (MASTER && AC) {
        MASTER.gain.cancelScheduledValues(AC.currentTime);
        MASTER.gain.setValueAtTime(muted ? 0 : 0.4, AC.currentTime);
      }
      return;
    }

    var fq = t.closest('.tdd-fq');
    if (fq) {
      var item = fq.parentNode;
      if (item.classList.contains('tdd-open')) { item.classList.remove('tdd-open'); }
      else { item.classList.add('tdd-open'); }
      return;
    }
  }, false);

  document.addEventListener('keydown', function (ev) {
    var m = id('tddm');
    if (!m || !m.classList.contains('tddm-open')) { return; }
    if (ev.key === 'Escape') { closePop(); }
    else if (ev.key === 'Enter' && ev.target && ev.target.id === 'tddm-email') { ev.preventDefault(); submitPop(); }
  }, false);

  /* init robuste : setInterval + MutationObserver + DOMContentLoaded */
  var tries = 0;
  var iv = window.setInterval(function () {
    tries++;
    if (boot() || tries > 40) { window.clearInterval(iv); }
  }, 150);

  if (window.MutationObserver) {
    var mo = new window.MutationObserver(function () { if (boot()) { mo.disconnect(); } });
    mo.observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, false);
  } else {
    boot();
  }

}());
} catch(error){console.error(error);}